<script lang="ts">
    import { gettext as _, tgettext } from 'hydria/services/gettext'
    import { simpleFetch } from 'hydria/services/session'
    import { sanchor, spath } from 'hydria/svelte_helpers'
    import { toLuxon } from 'hydria/utils/time'

    import type { ZoneTemplate } from 'wdom/zone/zone'
    import { Breadcrumb } from 'breadcrumb'

    import Date from 'hydria/components/Date.svelte'

    let items: ZoneTemplate[] = $state([])
    let loading = $state(true)

    simpleFetch('GET', '/json/zone/1/zone-templates')
        .then((r) => {
            items = r.data.items
            for (const item of items) {
                item.mtime = toLuxon(item.mtime)
            }
            loading = false
        })
        .catch((e) => {
            loading = false
        })
</script>

<Breadcrumb crumbs={[{ txt: tgettext('Zone templates') }]} />

{#if loading}
    <div class="card">
        <div class="card-body">
            <div class="m-4 d-flex justify-content-center align-items-center">
                <div class="spinner-border me-3" role="status" aria-hidden="true"></div>
            </div>
        </div>
    </div>
{:else}
    <div class="card">
        <div class="card-title text-primary">{$_('Zone templates')}</div>
        <div class="card-body">
            <table class="table table-striped mb-0">
                <thead>
                    <tr>
                        <th>{$_('Nom (fr)')}</th>
                        <th>{$_('Nom (en)')}</th>
                        <th class="text-center">{$_('Dernière modification')}</th>
                    </tr>
                </thead>
                <tbody>
                    {#each items as item (item.id)}
                        <tr>
                            <td><a use:sanchor href={spath(`/zone-template/${item.id}`)}>{item.name_fr}</a></td>
                            <td><a use:sanchor href={spath(`/zone-template/${item.id}`)}>{item.name_en}</a></td>
                            <td class="text-center"><Date value={item.mtime} format="h-table-s" /></td>
                        </tr>
                    {/each}
                </tbody>
            </table>
        </div>
        <div class="card-footer text-bg-light">
            <div class="row">
                <div class="col-sm-5 create-new">
                    <a use:sanchor href={spath('/zone-template/new')} class="btn btn-primary">{$_('Nouveau modèle')}</a>
                </div>
            </div>
        </div>
    </div>
{/if}
